'use client';

import React, { createContext, useContext, useState, useEffect } from 'react';

const LocaleContext = createContext<string>('en-GB');

export function LocaleProvider({ children, serverLocale }: { children: React.ReactNode, serverLocale: string }) {
  return (
    <LocaleContext.Provider value={serverLocale}>
      {children}
    </LocaleContext.Provider>
  );
}

export function useLocale(): string {
  const serverLocale = useContext(LocaleContext);
  const [locale, setLocale] = useState(serverLocale);

  useEffect(() => {
    setLocale(navigator.language || serverLocale);
  }, [serverLocale]);

  return locale;
}
